import React,{useContext,useEffect,useMemo,useState} from 'react'
import { UserSettingsContext } from '../../setup/routes-manager/RequireAuth'
import { useAxiosWithAuth } from '../../common/api/hooks/useAxiosWithAuth';
import { URL } from '../../common/api/urls';
import { useNavigate } from 'react-router-dom';
import ActiveSessionsList from '../../components/sessions/ActiveSessionsList';
import LogoutOtherSessionsDialog from '../../components/sessions/LogoutOtherSessionsDialog';
import { mapApiSessionsToRows } from '../../common/utility/activeSessionsMapper';
import { TEXT_MSGS } from '../../common/utility/constant';
import { CircularProgress,IconButton, InputLabel,Switch,Radio,RadioGroup,FormControlLabel,FormLabel, Link } from '@mui/material';
import {Grid, Box,Typography,Select,ListSubheader,TextField,InputAdornment,FormControl,MenuItem} from "@mui/material";
import { MuiTelInput } from 'mui-tel-input';
import PersonIcon from '@mui/icons-material/Person';
import AppErrorPopup from '../../components/AppErrorPopup';
import EmailIcon from '@mui/icons-material/Email';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import LockIcon from '@mui/icons-material/Lock';
import {
  ProfileCard,
  ProfileCardActions,
  ProfileDefinitionRow,
  ProfileFieldRow,
  PROFILE_VALUE_TEXT_SX,
} from '../../components/profile/ProfileCard';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import VerifiedIcon from '@mui/icons-material/Verified';
import useAuth from '../../common/hooks/useAuth';
import MobileOtpVerificationDialog from '../login-register/register/MobileOtpVerificationDialog';
import {
  getContactValidationError,
  toContactDigits,
  toContactTelInput,
} from '../../common/utility/validators';

const UserProfile = () => {
  const from = "/login";
  const navigate = useNavigate();
  const { auth } = useAuth();

  const [userDetailsState,setUserDetailsState]=useState({
    isLoaded:false,
    data:undefined,
    currentContact:"",
    currentEmail:"",
    currentPassword:"",
    updatedPassword:"",
    currentFirstName:"",
    currentLastName:"" ,
    currentGstNum:"" ,
    currentCompanyName:"" ,
    currentAddress:"" ,
  })

  const {isLoaded,data,currentContact,currentEmail,currentPassword,updatedPassword,currentFirstName,currentLastName,currentGstNum,currentCompanyName,currentAddress}=userDetailsState;

  const [editName,setEditName]=useState(false);
  const [editEmail,setEditEmail]=useState(false);
  const [editContact,setEditContact]=useState(false);
  const [editPassword,setEditPassword]=useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [editGstNum, setEditGstNum] = useState(false);
  const [editCompanyName, setEditCompanyName] = useState(false);
  const [editAddress, setEditAddress] = useState(false);
  const [contactOtpOpen, setContactOtpOpen] = useState(false);
  const [pendingContact, setPendingContact] = useState(null);
  const [msgState, setMsgState] = useState({
    open: false,
    msg:"" ,
    severity:"info"
  });
  
  const { open, msg, severity } = msgState;
  const [cancel,responseData, error, loaded, reset,executeAPI ] = useAxiosWithAuth();
  const [cancelSave,responseDataSave, errorSave, loadedSave, resetSave,executeAPISave ] = useAxiosWithAuth();
  const [cancelPassword,responseDataPassword, errorPassword, loadedPassword, resetPassword,executeAPIPassword ] = useAxiosWithAuth();
  const [
    ,
    responseLogoutOthers,
    errorLogoutOthers,
    loadedLogoutOthers,
    resetLogoutOthers,
    executeLogoutOthers,
  ] = useAxiosWithAuth();
  const [logoutOtherSessionsLoading, setLogoutOtherSessionsLoading] = useState(false);
  const [logoutOthersDialogOpen, setLogoutOthersDialogOpen] = useState(false);

  const normalizeStoredContact = (contact) => {
    if (!contact) return '';
    return String(contact).replace(/\D/g, '');
  };

  /**
 * autoclosing of the snackbar msg bar 
 */ 
  const handleClose = (event, reason) => {
    setMsgState({...msgState,open:false});
};

useEffect(() => {
  document.title = "Profile Details";
}, []);

  const profileSessions = useMemo(
    () => mapApiSessionsToRows(data?.sessions),
    [data?.sessions],
  );

  const otherProfileSessions = useMemo(
    () => profileSessions.filter((row) => !row.is_current),
    [profileSessions],
  );

  useEffect(()=>{
    executeAPI(URL.USER_DETAILS,"GET",{});
  },[]);

  const handleLogoutOtherSessions = () => {
    setLogoutOthersDialogOpen(true);
  };

  const handleCloseLogoutOthersDialog = () => {
    if (logoutOtherSessionsLoading) return;
    setLogoutOthersDialogOpen(false);
  };

  const handleConfirmLogoutOtherSessions = () => {
    setLogoutOtherSessionsLoading(true);
    resetLogoutOthers();
    executeLogoutOthers(URL.LOGOUT, 'POST', { clear: 1 });
  };

  useEffect(() => {
    if (!loadedLogoutOthers) return;
    setLogoutOtherSessionsLoading(false);
    if (responseLogoutOthers != null) {
      setLogoutOthersDialogOpen(false);
      setMsgState({
        open: true,
        msg:
          responseLogoutOthers?.message ||
          'Other sessions were signed out successfully.',
        severity: 'success',
      });
      resetLogoutOthers();
      executeAPI(URL.USER_DETAILS, 'GET', {});
    } else if (errorLogoutOthers != null) {
      setMsgState({
        open: true,
        msg:
          errorLogoutOthers?.response?.data?.message ??
          TEXT_MSGS.NETWORK_ERROR_MSG,
        severity: 'info',
      });
      resetLogoutOthers();
    }
  }, [loadedLogoutOthers, responseLogoutOthers, errorLogoutOthers]);
  /**
 * API response handler  for user details
 */  
  useEffect(() => {
    if(loaded){
    
      if(responseData!=null){
        setUserDetailsState((prevState)=>({
            ...prevState,
           isLoaded:true,
           data:responseData.data,
           currentContact: responseData.data.is_contact_verified
             ? normalizeStoredContact(responseData.data.contact)
             : '',
           currentEmail:responseData.data.email_id,
           currentFirstName:responseData.data.first_name,
           currentLastName:responseData.data.last_name,
           currentGstNum:responseData.data.gstin,
           currentCompanyName:responseData.data.company_name,
           currentAddress:responseData.data.address,
          }));
      }
      else if(error!==null){
        console.log("Error data=",error);
        setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        //if unauthorized then redirect it to login page
        if(error?.response?.status === 401 || error?.response?.status === 403){
          console.log("status received =",error?.response?.status)
          navigate(from, { replace: true });
        }
    }
    reset();
    }
  },[loaded,responseData]);

  const handleNameEdit=()=>{
    setEditName(true);
  }

  const handleEmailEdit=()=>{
    setEditEmail(true);
  }
  const handleContactEdit=()=>{
    setEditContact(true);
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentContact: data?.is_contact_verified ? toContactTelInput(data?.contact) : '',
    }));
  }

  const handlePasswordEdit=()=>{
    setEditPassword(true);
  }

  const handleGstDetailsEdit=()=>{
    setEditGstNum(true);
    setEditCompanyName(true);
    setEditAddress(true);
  }

  const handleFirstNameChange=(event)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentFirstName:event.target.value
    }))
  }

  const handleLastNameChange=(event)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentLastName:event.target.value
    }))
  }
  
  const handleEmailChange=(event)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentEmail:event.target.value
    }))
  }

  const handleContactChange=(value)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentContact: value,
    }))
  }

  const handleGstNumChange=(event)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentGstNum:event.target.value
    }))
  }

  const handleCompanyNameChange=(event)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentCompanyName:event.target.value
    }))
  }

  const handleAddressChange=(event)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentAddress:event.target.value
    }))
  }

  const cancleProfileDetailsEdit=()=>{
    setEditEmail(false);
    setEditContact(false);
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentContact: data?.is_contact_verified ? normalizeStoredContact(data?.contact) : '',
      currentEmail:data.email_id
    }))
  }

  const cancleGstDetailsEdit=()=>{
    setEditGstNum(false);
    setEditCompanyName(false);
    setEditAddress(false);
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentGstNum:data.gstin,
      currentCompanyName:data.company_name,
      currentAddress:data.address
    }))
  }

  const cancleNameEdit=()=>{
    setEditName(false);
    
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentFirstName:data.first_name,
      currentLastName:data.last_name
    }))
  }

  const handlePasswordChange=(event)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentPassword:event.target.value
    }))
  }

  const handleConfirmPasswordChange=(event)=>{
    setUserDetailsState((prevState)=>({
      ...prevState,
      updatedPassword:event.target.value
    }))
  }

  const cancelUpdatePassword=()=>{
    setEditPassword(false)
    setUserDetailsState((prevState)=>({
      ...prevState,
      currentPassword:"",
      updatedPassword:""
    }))
  }

  const validateEmailId=()=>{
    if (!currentEmail.trim()) {
     return false;
    }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(currentEmail.trim())) {
      return false;
    }
    return true;
  }

  const validateContact=()=> !getContactValidationError(currentContact);

  const hasContactChanged = () => {
    if (!data?.is_contact_verified) {
      return Boolean(currentContact?.trim());
    }
    return toContactDigits(currentContact) !== normalizeStoredContact(data?.contact);
  };

  const getContactFieldLabel = () => (
    data?.is_contact_verified ? 'Enter New Number' : 'Verify your contact'
  );

  const getContactHelperText = () => {
    if (!data?.is_contact_verified && !currentContact?.trim()) {
      return 'Enter your mobile number to verify';
    }
    if (!validateContact()) {
      return getContactValidationError(currentContact) || 'Mobile no. is invalid';
    }
    return ' ';
  };

  const showContactFieldError = () => {
    if (!data?.is_contact_verified && !currentContact?.trim()) {
      return false;
    }
    return !validateContact();
  };

  const handleSaveContactDetails = () => {
    if (!validateContact() || !validateEmailId()) return;

    if (editContact && hasContactChanged()) {
      setPendingContact(currentContact);
      setContactOtpOpen(true);
      return;
    }

    if (editEmail) {
      saveUserDetails();
    }
    setEditContact(false);
    setEditEmail(false);
  };

  const handleContactOtpClose = () => {
    setContactOtpOpen(false);
    setPendingContact(null);
  };

  const handleContactVerifySuccess = () => {
    setContactOtpOpen(false);
    setPendingContact(null);
    setEditContact(false);
    executeAPI(URL.USER_DETAILS, 'GET', {});
    setMsgState({
      open: true,
      msg: `${TEXT_MSGS.USER_DETAILS_UPDATED_SUCCESSFULLY}`,
      severity: 'success',
    });
  };

  const validateTextData=()=>{
    // if (!currentEmail.trim()) {
    //  return false;
    // }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(currentEmail.trim())) {
    //   return false;
    // }
    return true;
  }

  const saveUserDetails=()=>{
    let newData={
      first_name:currentFirstName,
      last_name:currentLastName,
      email_id:currentEmail,
    }
    executeAPISave(URL.UPDATE_USER,"POST",newData);
  }

  const saveGstDetails=()=>{
    let newData={
      gstin:currentGstNum,
      company_name:currentCompanyName,
      address:currentAddress,
    }
    executeAPISave(URL.UPDATE_USER,"POST",newData);
  }

  /**
 * API response handler save user details
 */  
  useEffect(() => {
    if(loadedSave){
      if(responseDataSave!=null){
        let updatedData={ ...data };
        updatedData.first_name=currentFirstName;
        updatedData.last_name=currentLastName;

        setUserDetailsState((prevState)=>({
            ...prevState,
           isLoaded:true,
           data:updatedData,
           currentContact: data?.is_contact_verified ? normalizeStoredContact(data.contact) : '',
           currentEmail:currentEmail,
           currentFirstName:currentFirstName,
           currentLastName:currentLastName,
           currentGstNum:currentGstNum,
           currentCompanyName:currentCompanyName,
           currentAddress:currentAddress,
          }));
          setMsgState({open:true,msg:`${TEXT_MSGS.USER_DETAILS_UPDATED_SUCCESSFULLY}`,severity:"success"});
          setEditContact(false);
          setEditEmail(false);
          setEditName(false);
          setEditGstNum(false);
          setEditCompanyName(false);
          setEditAddress(false);
      }
      else if(errorSave!==null){
        setMsgState({open:true,msg:errorSave?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        //if unauthorized then redirect it to login page
        if(errorSave?.response?.status === 401 || errorSave?.response?.status === 403){
          navigate(from, { replace: true });
        }
    }
    resetSave();
    }
  },[loadedSave,responseDataSave]);

  const savePassword=()=>{
    let newData={
      current_password:currentPassword,
      new_password:updatedPassword
    }
    executeAPIPassword(URL.UPDATE_PASSWORD,"POST",newData);

  }

  /**
 * API response handler update user password
 */  
  useEffect(() => {
    if(loadedPassword){
      if(responseDataPassword!=null){
        setMsgState({open:true,msg:`${TEXT_MSGS.PASSWORD_UPDATED_SUCCESSFULLY}`,severity:"success"});
         setEditPassword(false)
      }
      else if(errorPassword!==null){
        setMsgState({open:true,msg:errorPassword?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        //if unauthorized then redirect it to login page
        if(errorPassword?.response?.status === 401 || errorPassword?.response?.status === 403){
          navigate(from, { replace: true });
        }
    }
    resetSave();
    }
  },[loadedPassword,responseDataPassword]);




  return (
    <>
    {isLoaded?
    <>      
      <Grid container spacing={2} sx={{ px: { mobile: 1, tablet: 0 }, mb: 4 }}>
        <Grid item mobile={0} tablet={1} laptop={1} />

        <Grid item mobile={12} tablet={10} laptop={10}>
        <Typography sx={{ mt: 2, fontSize: 18 }}>Profile Details</Typography>

        <ProfileCard
          title="Full Name"
          editLabel="Edit full name"
          onEdit={handleNameEdit}
          editing={editName}
          actions={editName ? (
            <ProfileCardActions
              onCancel={cancleNameEdit}
              onSave={saveUserDetails}
              saveDisabled={currentFirstName.trim() === '' || currentLastName.trim() === ''}
            />
          ) : null}
        >
          {editName ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: 0.5 }}>
              <TextField
                fullWidth
                value={currentFirstName}
                onChange={handleFirstNameChange}
                label="First name"
                variant="filled"
                error={currentFirstName.trim() === ''}
                helperText={currentFirstName.trim() === '' ? 'Enter valid first name' : ' '}
              />
              <TextField
                fullWidth
                value={currentLastName}
                onChange={handleLastNameChange}
                label="Last name"
                variant="filled"
                error={currentLastName.trim() === ''}
                helperText={currentLastName.trim() === '' ? 'Enter valid last name' : ' '}
              />
            </Box>
          ) : (
            <ProfileFieldRow icon={<PersonIcon fontSize="small" />}>
              <Typography sx={PROFILE_VALUE_TEXT_SX}>
                {currentFirstName}&nbsp;{currentLastName}
              </Typography>
            </ProfileFieldRow>
          )}
        </ProfileCard>

        <ProfileCard
          title="Contact Details"
          hint="As an NSE and BSE exchange-connected platform, Vtrender Charts is required maintain verified user contact details at all times."
          editLabel="Edit contact details"
          onEdit={handleContactEdit}
          editing={editEmail || editContact}
          actions={editEmail || editContact ? (
            <ProfileCardActions
              onCancel={cancleProfileDetailsEdit}
              onSave={handleSaveContactDetails}
              saveDisabled={!validateContact() || !validateEmailId()}
              saveLabel={
                editContact
                  ? (data?.is_contact_verified ? 'Verify and Save Changes' : 'Verify Contact')
                  : 'Save Changes'
              }
            />
          ) : null}
        >
          <ProfileFieldRow icon={<EmailIcon fontSize="small" />}>
            {editEmail ? (
              <TextField
                fullWidth
                value={currentEmail}
                onChange={handleEmailChange}
                label="Email address"
                variant="filled"
                type="email"
                error={!validateEmailId()}
                helperText={!validateEmailId() ? 'Enter valid email id' : ' '}
              />
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75 }}>
                <Typography sx={PROFILE_VALUE_TEXT_SX}>{data.email_id}</Typography>
                {data.active && (
                  <VerifiedIcon
                    onClick={handleEmailEdit}
                    sx={{ height: 20, width: 20, cursor: 'pointer' }}
                    aria-label="Email verified"
                  />
                )}
              </Box>
            )}
          </ProfileFieldRow>

          <ProfileFieldRow icon={<PhoneAndroidIcon fontSize="small" />}>
            {editContact ? (
              <MuiTelInput
                sx={{ width: '100%', maxWidth: { mobile: '100%', tablet: 400 } }}
                size="small"
                value={currentContact || ''}
                onChange={handleContactChange}
                label={getContactFieldLabel()}
                variant="outlined"
                error={showContactFieldError()}
                helperText={getContactHelperText()}
                defaultCountry="IN"
                forceCallingCode
              />
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75 }}>
                <Typography
                  sx={{
                    ...PROFILE_VALUE_TEXT_SX,
                    color: data?.is_contact_verified ? 'inherit' : 'rgba(255,255,255,0.55)',
                  }}
                >
                  {data?.is_contact_verified && data.contact
                    ? normalizeStoredContact(data.contact)
                    : 'Verify your contact'}
                </Typography>
                {data.is_contact_verified && (
                  <VerifiedIcon sx={{ height: 20, width: 20 }} aria-label="Contact verified" />
                )}
              </Box>
            )}
          </ProfileFieldRow>
        </ProfileCard>

        <ProfileCard
          title="Password"
          editLabel="Change password"
          onEdit={handlePasswordEdit}
          editing={editPassword}
          actions={editPassword ? (
            <ProfileCardActions
              onCancel={cancelUpdatePassword}
              onSave={savePassword}
              saveDisabled={currentPassword.trim() === '' || updatedPassword.trim() === ''}
            />
          ) : null}
        >
          {editPassword ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: 0.5 }}>
              <TextField
                fullWidth
                value={currentPassword}
                onChange={handlePasswordChange}
                label="Current password"
                variant="filled"
                type={showPassword ? 'text' : 'password'}
                error={currentPassword.trim() === ''}
                helperText={currentPassword.trim() === '' ? 'Current password is required' : ' '}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                value={updatedPassword}
                onChange={handleConfirmPasswordChange}
                label="New password"
                variant="filled"
                type={showConfirmPassword ? 'text' : 'password'}
                error={updatedPassword.trim() === ''}
                helperText={updatedPassword.trim() === '' ? 'New password is required' : ' '}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle new password visibility"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        edge="end"
                      >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          ) : (
            <ProfileFieldRow icon={<LockIcon fontSize="small" />}>
              <Typography sx={PROFILE_VALUE_TEXT_SX}>**********</Typography>
            </ProfileFieldRow>
          )}
        </ProfileCard>

        <ProfileCard
          titleContent={(
            <>
              GST Details for Invoicing (Optional — email{' '}
              <Link href="mailto:charts@vtrender.com">charts@vtrender.com</Link> for a GST invoice)
            </>
          )}
          editLabel="Edit GST details"
          onEdit={handleGstDetailsEdit}
          editing={editGstNum || editAddress || editCompanyName}
          actions={editGstNum || editAddress || editCompanyName ? (
            <ProfileCardActions
              onCancel={cancleGstDetailsEdit}
              onSave={saveGstDetails}
              saveDisabled={!validateTextData()}
            />
          ) : null}
        >
          {editGstNum || editCompanyName || editAddress ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: 0.5 }}>
              <TextField
                fullWidth
                value={currentGstNum}
                onChange={handleGstNumChange}
                label="GSTIN"
                variant="filled"
                error={!validateTextData()}
                helperText={!validateTextData() ? 'GST Number' : ' '}
              />
              <TextField
                fullWidth
                value={currentCompanyName}
                onChange={handleCompanyNameChange}
                label="Company name"
                variant="filled"
                error={!validateTextData()}
                helperText={!validateTextData() ? 'Registered company name' : ' '}
              />
              <TextField
                fullWidth
                value={currentAddress}
                onChange={handleAddressChange}
                label="Company address with pincode"
                variant="filled"
                error={!validateTextData()}
                helperText={!validateTextData() ? 'Company address' : ' '}
              />
            </Box>
          ) : (
            <>
              <ProfileDefinitionRow label="GSTIN">
                {data.gstin !== undefined ? data.gstin : '-'}
              </ProfileDefinitionRow>
              <ProfileDefinitionRow label="Company name">
                {data.company_name !== undefined ? data.company_name : '-'}
              </ProfileDefinitionRow>
              <ProfileDefinitionRow label="Company address">
                {data.address !== undefined ? data.address : '-'}
              </ProfileDefinitionRow>
            </>
          )}
        </ProfileCard>

        <ProfileCard
          id="active-sessions"
          title="Active sessions"
          hint={(
            <>
              Review where your account is signed in. The row marked{' '}
              <Box component="span" sx={{ color: 'success.main', fontWeight: 600 }}>
                This device
              </Box>{' '}
              is the browser you are using now.
            </>
          )}
          showEdit={false}
        >
          <Box sx={{ pt: 0.5, width: '100%' }}>
            <ActiveSessionsList
              sessions={profileSessions}
              loading={false}
              error={null}
              onLogoutOtherSessions={handleLogoutOtherSessions}
              logoutOtherSessionsLoading={logoutOtherSessionsLoading}
            />
          </Box>
        </ProfileCard>
        </Grid>

        <Grid item mobile={0} tablet={1} laptop={1} />
      </Grid>
      </>
      :
      <CircularProgress sx={{marginTop:"20%",marginLeft:"45%"}}/>}
       <AppErrorPopup
         open={open}
         message={msg}
         severity={severity}
         onClose={handleClose}
         showCloseX
       />

      <LogoutOtherSessionsDialog
        open={logoutOthersDialogOpen}
        onClose={handleCloseLogoutOthersDialog}
        onConfirm={handleConfirmLogoutOtherSessions}
        loading={logoutOtherSessionsLoading}
        otherSessions={otherProfileSessions}
      />

      {pendingContact && auth?.email_id && (
        <MobileOtpVerificationDialog
          open={contactOtpOpen}
          contact={pendingContact}
          displayContact={pendingContact}
          email={auth.email_id}
          allowEditContact
          dismissible
          onClose={handleContactOtpClose}
          onVerifySuccess={handleContactVerifySuccess}
          onSkip={handleContactOtpClose}
        />
      )}
       {/* Legacy snackbar (replaced by AppErrorPopup)
       <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}} sx={{top:"48px"}} open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} >
          <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
            {msg}
          </Alert>  
       </Snackbar>
       */}
      </>
  )
}

export default UserProfile
